import { useMemo } from 'react';

import { fg } from '@confluence/feature-gating';
import type { EditorClassificationTagWrapperProps } from '../EditorComponentsV2/EditorClassificationTagWrapper';

export const useShouldRenderEditorActionBarClassificationPlaceholder = (
	props: EditorClassificationTagWrapperProps,
): boolean => {
	const { isDataClassificationEnabledForOrg, contentClassificationMetadata } = props;

	const { hasNoClassification, contentLevelLoading } = contentClassificationMetadata;

	//Reassign value based on the feature flag, keeping same name in case memcache lookup uses specific name
	const classificationEnabledFinalEvaluation = fg('disable_classification_enabled_query')
		? (contentClassificationMetadata?.featureEnabled ?? false)
		: isDataClassificationEnabledForOrg;

	return useMemo(() => {
		if (!classificationEnabledFinalEvaluation) return false;
		if (hasNoClassification) return false;
		if (contentLevelLoading) return false;
		return true;
	}, [contentLevelLoading, hasNoClassification, classificationEnabledFinalEvaluation]);
};
